module.exports = __webpack_public_path__ + "static/media/loader_gif_fisdom.ca21fc75.gif";